<template>
  <VDialog
    :open="isOpen"
    headline="Import status"
    modal
    full-width-body
    @close="$emit('dismiss')"
    style="--dialog-inline-size: 80vw; --dialog-max-inline-size: 900px;"
  >
    <template #body>  
      <div class="import_customers">
        <!-- Loading state -->
        <div v-if="uploadedFilesLoader" class="text-center flex-center h-50vh">
          <div>
            <img src="@/resources/images/importing_status.svg" alt="Importing" class="emptyImg" />
            <h5>Please wait...</h5>
          </div>
        </div>

        <!-- Files loaded state -->
        <div v-else-if="uploadedListOfFiles.length > 0">
          <div class="infoBanner marginBottom">
            <VIcon name="info-line" :size="-5" connotation="cta" class="infoIcon" />
            <p class="vtext-body">Only files from the last 7 days will appear here.</p>
          </div>

          <!-- Table header -->
          <div class="import-table">
            <div class="import-row import-header">
              <div class="col-filename"><span class="vtext-subtitle">File name</span></div>
              <div class="col-importedby desktop-only"><span class="vtext-subtitle">Imported by</span></div>
              <div class="col-importedon desktop-only"><span class="vtext-subtitle">Imported on</span></div>
              <div class="col-status"><span class="vtext-subtitle">Status</span></div>
            </div>

            <!-- Table rows -->
            <div v-for="(file, index) in uploadedListOfFiles" :key="index" class="import-row">
              <div class="col-filename overflowTitle">
                <span class="vtext-body">{{ file.file_name }}</span>
              </div>
              <div class="col-importedby desktop-only">
                <span class="vtext-body">{{ file.imported_by_useremail }}</span>
              </div>
              <div class="col-importedon desktop-only">
                <span class="vtext-body">{{ renderDateTime_lastReplyTimestamp(file.import_initiated_timestamp, 'customReadable', false) }}</span>
              </div>
              <div class="col-status status-info">
                <div class="iconContainer vpb-10">
                  <VIcon name="check-circle-line" :size="-4" connotation="success" class="successIcon" />
                  <p class="vtext-subtitle"><b class="primaryBlack">{{ file?.success_count }}</b> Successful</p>
                </div>
                <div class="failed-flex">
                  <div class="iconContainer" :class="{ successStatus: file?.failure_count == 0 }">
                    <VIcon name="error-line" :size="-4" connotation="alert" class="trashIcon" />
                    <p class="vtext-subtitle"><b class="primaryBlack">{{ file?.failure_count }}</b> Failed</p>
                  </div>
                  <div class="flex-center">
                    <span v-if="file?.failure_count > 0" class="tooltip_container">
                      <VIcon name="download-line" class="primaryBlack cursorPointer" @click="$emit('download-failed', file.id, file.file_name)" />
                      <span class="tooltip_text left" style="width: 200px">Download Failed Customers</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Empty state -->
        <div v-else class="text-center flex-center h-50vh">
          <div>
            <img src="@/resources/images/not-found.svg" alt="No files found" class="emptyImg" />
            <h5>No Imported Files yet! 😟</h5>
          </div>
        </div>
      </div>
    </template>
  </VDialog>
</template>

<script>
import { renderDateTime_lastReplyTimestamp } from '@/helpers/date.helpers';

export default {
  name: 'ImportStatusModal',
  props: {
    isOpen: { type: Boolean, required: true },
    uploadedListOfFiles: { type: Array, default: () => [] },
    uploadedFilesLoader: { type: Boolean, default: false },
  },
  emits: ['dismiss', 'download-failed'],
  methods: {
    renderDateTime_lastReplyTimestamp,
  },
};
</script>

<style scoped>
.import_customers {
  margin: 20px;
}
.infoBanner {
  margin-top: 10px;
  background: var(--purple-opac);
  border-radius: 5px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.infoBanner p {
  font-size: 12px;
  color: var(--black) !important;
  font-weight: 400;
  margin: 0;
}
.infoIcon {
  color: var(--purple);
  width: 20px;
  height: 20px;
}
.emptyImg {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.h-50vh {
  height: 50vh;
}

/* Table layout */
.import-table {
  width: 100%;
}
.import-row {
  display: grid;
  grid-template-columns: 4fr 4fr 2fr 2fr;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid var(--background-primary);
  gap: 10px;
}
.import-header {
  padding-bottom: 15px;
  margin-bottom: 10px;
}
.col-filename { min-width: 0; }
.col-importedby { min-width: 0; }
.col-importedon { min-width: 0; }
.col-status { min-width: 0; }
.text-right { text-align: right; }
.overflowTitle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.status-info {
  padding-top: 10px;
}
.iconContainer, .failed-flex {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}
.successStatus {
  padding-right: 40px;
}

/* Responsive */
.desktop-only {
  display: block;
}
@media only screen and (max-width: 760px) {
  .desktop-only {
    display: none;
  }
  .import-row {
    grid-template-columns: 8fr 4fr;
  }
}
</style>
